import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@zebra-fed/zds-react-desktop';
import TextField from '@material-ui/core/TextField';
import '@zebra-fed/icons/General/index.css';
import { useTranslation } from "react-i18next";
import SearchIcon from '@material-ui/icons/Search';
import { Button, RadioButtonGroup, Item, Radio } from "@zebra-fed/zds-react-desktop";
import RefreshIcon from '@material-ui/icons/Refresh';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControl";
const RefreshIconStyled = styled(RefreshIcon)`
    fill: #0073E6 !important;
    margin-right: 20px;
    border-style:solid;
    border-radius: 4px;
    border-width: thin;
    padding:4px;
    border-color: #0073E6;
    &:hover {
        cursor: pointer;
    }
`;

const ToolbarWrapper = styled.div`
    display: flex;
    // justify-content: space-between;
    justify-content: end;
    align-items: center;
    // padding: 0 18px;
    // border: 2px solid red;
    position: absolute;
    z-index: 999;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -65px;
    display: flex;
    flex-direction: row;
    // background: lightblue;
    align-items: end;
    // border: 1px solid;
    width: fit-content;
    right: 0;
    left: auto;
    padding: 5px;
    // background: #007ABA;
    border-radius: 4px;
    margin-right: 0;
    margin-left: auto;
    // border: 1px solid #bdbdbd;
    @media screen and (max-width: 750px) {
        right: auto;
        padding-left: 0;
        margin-top: 10px;
        width: 100%;
        justify-content: space-between;
    }

`
const SearchIconCustom = styled(SearchIcon)`
    position: relative;
    &:hover {
        cursor: pointer;
    }
`;

const TitleText = styled.h1`
    font-size: 20px;
    display: flex;
`

const SearchBoxNComp = styled.div`
    background: white;
    // margin-right: 15px;
    padding: 10px;
    border: 1px solid #bdbdbd;
    position: absolute;
    top: 36px;
    z-index: 999;
    width: max-content;
`;

export default function Toolbar(props) {
    const { multiSearchOpts = [], onRefreshClick, disabled = false } = props;
    const [searchVal, setSearchVal] = useState('');
    const [isError, setIsError] = useState(false)
    const { t } = useTranslation();
    const [openSearchBox, setOpenSearchBox] = useState(false)
    const [searchOptVal, setSearchOptVal] = useState('')
    const radioRef = createRef();
    const [searchInputError, setSearchInputError] = useState("")
    const [searchOptError, setSearchOptError] = useState("")
    // console.log('searchOptVal :', searchOptVal);

    useEffect(() => {
        setSearchVal(props.searchText)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function searchTheVal() {
        // console.log('clicked clicked')
        // console.log(radioRef.current.getValues());
        let optLength = radioRef.current.getValues().length;
        // console.log('optLength :', optLength);

        if (!searchVal) {
            setSearchInputError('Enter a value to search')
        }
        if (multiSearchOpts.length > 0 && optLength === 0) {
            setSearchOptError('Choose a type')
        }

        else {
            props.onSearch(searchVal, searchOptVal)
        }

    }

    function onChangeOptItem(e) {
        setSearchOptError("");
        setSearchOptVal(e.target.value);
    }

    function onChangeSearchBox(e) {
        let value = e.target.value;
        // let regexVal = value.replace(/[^a-zA-Z0-9.:,#$[\]]/gi, '');
        // let regexVal = value.replace(/[^-?a-zA-Z0-9_:;+=<>?'"!@%^&*(){}|\//\s]/gi, '');
        // setSearchVal(e.target.value.trim());
        setSearchVal(value);
        setSearchInputError("")
        if (e.target.value === "") {
            props.onClear(searchVal);
        }
    }

    return (
        <ToolbarWrapper>
            <RefreshIconStyled onClick={onRefreshClick} />
            <TextField
                id={props.id}
                disabled={disabled}
                error={isError}
                helperText={isError ? t('macNFriendlyNamTextFielde') : ""} //"Please enter a valid email id to search."
                style={{}}
                placeholder={t('search')}
                value={searchVal}
                onFocus={() => setOpenSearchBox(true)}
                // onBlur={()=>setOpenSearchBox(false)}
                onChange={(e) => {
                    onChangeSearchBox(e)
                }}
                onKeyDownCapture={multiSearchOpts.length === 0 ? (e) => {
                    if (e.keyCode === 13) {
                        if (e.target.value.trim() === "")
                            setIsError(true)

                        props.onSearch(searchVal)
                    }
                } : () => { }}
                InputProps={{
                    startAdornment:
                        <Icon
                            category={'general'}
                            name={'search'}
                            size={15}
                            style={{ cursor: 'pointer', padding: '0 8px 4px 0' }}
                            color={'#bdbdbd'}
                        />,
                    endAdornment:
                        <Icon
                            category={'navigation'}
                            name={'close'}
                            size={15}
                            style={{
                                cursor: 'pointer', paddingRight: '4px',
                                visibility: searchVal === '' ? 'hidden' : 'visible'
                            }}

                            color={'#bdbdbd'}
                            onClick={() => {
                                if (searchVal) {
                                    setSearchVal('')
                                    props.onClear(searchVal)
                                }
                            }}
                        />,
                }}
            />
            {
                openSearchBox && multiSearchOpts.length > 0 &&
                <SearchBoxNComp>

                    {searchInputError && <p style={{ color: 'red', margin: '0' }}>{searchInputError}</p>}
                    <p>{t('matchResultIn')}:</p>
                    {/* <FormControl> */}
                    <RadioButtonGroup
                        align="left"
                        ref={radioRef}
                        onChange={onChangeOptItem}
                    >
                        {multiSearchOpts.map((opts, idx) =>
                            <item
                                key={idx}
                                style={{display: opts.disable ? 'none' : '',}}
                                defaultChecked={opts.value === searchOptVal}
                                // onChange={()=>setSearchOptError("")}
                                value={opts.value}>
                                <span id={opts.id} style={{ display: opts.disable ? 'none' : '', }}>
                                    {opts.name}
                                </span>
                            </item>)}
                    </RadioButtonGroup>
                    {/* </FormControl> */}

                    {searchOptError && <p style={{ color: 'red', margin: '0' }}>{searchOptError}</p>}

                    <div>
                        <Button
                            id={`${props.id}-cancel`}
                            type="primary"
                            dense={true}
                            style={{ margin: '10px', backgroundColor: '#757575' }}
                            onClick={() => setOpenSearchBox(!openSearchBox)}
                        >{t('cancel')}</Button>
                        <Button
                            id={`${props.id}-search`}
                            type="primary"
                            dense={true}
                            style={{ margin: '10px' }}
                            onClick={() => searchTheVal()}
                            disabled={searchVal.trim() && searchOptVal ? false : true}
                        >{t('search')}</Button>
                    </div>
                </SearchBoxNComp>
            }

        </ToolbarWrapper>
    )
}